import React, { Component } from "react";
import { I18n } from "react-i18next";
import i18n from "../../../i18n";
import nl from "assets/icons/lang/nl.svg";
import en from "assets/icons/lang/uk.svg";
import de from "assets/icons/lang/de.svg";
import fr from "assets/icons/lang/fr.svg";
// import ge from 'assets/icons/lang/ge.svg';

export default class Language extends Component {
  render() {
    const getCountry = value => {
      let country = "";
      switch (value) {
        case "nl":
          country = nl;
          break;
        case "en":
          country = en;
          break;
        case "de":
          country = de;
          break;
        case "fr":
          country = fr;
          break;
      }
      return country;
    };
    return (
      <I18n>
        {(t, { i18n }) => (
          <div className="language-selector">
            <a href="#!" className="selected-language">
              <img src={getCountry(t("lang"))} alt={getCountry(t("lang"))} />
            </a>
            <ul>
              <li className="language-item">
                <a
                  href="#!"
                  onClick={() => {
                    i18n.changeLanguage("nl");
                  }}
                >
                  <img src={nl} alt={nl} />
                  <span>Nederlands</span>
                </a>
              </li>
              <li className="language-item">
                <a
                  href="#!"
                  onClick={() => {
                    i18n.changeLanguage("en");
                  }}
                >
                  <img src={en} alt={en} />
                  <span>English</span>
                </a>
              </li>
              <li className="language-item">
                <a
                  href="#!"
                  onClick={() => {
                    i18n.changeLanguage("de");
                  }}
                >
                  <img src={de} alt={de} />
                  <span>Deutsch</span>
                </a>
              </li>
              <li className="language-item">
                <a
                  href="#!"
                  onClick={() => {
                    i18n.changeLanguage("fr");
                  }}
                >
                  <img src={fr} alt={fr} />
                  <span>français</span>
                </a>
              </li>
            </ul>
          </div>
        )}
      </I18n>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Navigation/Language.jsx